import { CKLayoutGridAuto } from 'clearkit';

import {
  ListEnrichment,
  ListForms,
  ListTargetMarkets,
  ListVisitors,
} from '../GetStartedChecklists';

export const HomeSectionOnboarding = () => {
  return (
    <section className="space-y-6">
      <CKLayoutGridAuto gap="3rem" minWidth="25rem">
        <ListEnrichment />
        <ListForms />
        <ListTargetMarkets />
        <ListVisitors />
      </CKLayoutGridAuto>
    </section>
  );
};
